import React from 'react';
import cx from 'classnames';

/**
 * @typedef {object} MuiSelectUpDownProps
 * @property {string|Array<string>} [className]
 * @property {boolean} [disableDownArrow]
 * @property {boolean} [disableUpArrow]
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} [onClickDown]
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} [onClickUp]
 * @property {string} [upDownId]
 * @property {boolean} [preventUpDownBtnTabFocus]
 */

/**
 * @param {MuiSelectUpDownProps} props
 */
const MuiSelectUpDown = props => {
  const {
    className,
    disableDownArrow,
    disableUpArrow,
    onClickDown,
    onClickUp,
    upDownId,
    preventUpDownBtnTabFocus
  } = props;

  return (
    <div className={cx('mui-select-up-down', className)}>
      <button
        id={upDownId !== undefined ? upDownId + '-up-button' : ''}
        data-testid={upDownId !== undefined ? upDownId + '-up-button' : ''}
        disabled={disableUpArrow}
        type='button'
        className={cx('mui-select-up-down__up', { 'disabled-arrow': disableUpArrow })}
        onClick={onClickUp}
        {...(preventUpDownBtnTabFocus ? { tabIndex: -1 } : {})}>
        &#9650;
      </button>

      <button
        id={upDownId !== undefined ? upDownId + '-down-button' : ''}
        data-testid={upDownId !== undefined ? upDownId + '-down-button' : ''}
        disabled={disableDownArrow}
        type='button'
        className={cx('mui-select-up-down__down', { 'disabled-arrow': disableDownArrow })}
        onClick={onClickDown}
        {...(preventUpDownBtnTabFocus ? { tabIndex: -1 } : {})}>
        &#9660;
      </button>
    </div>
  );
};

export default MuiSelectUpDown;
